/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLoader2 = createReactComponent("loader-2", "IconLoader2", [
  ["path", { d: "M12 3a9 9 0 1 0 9 9", key: "svg-0" }]
]);

export { IconLoader2 as default };
//# sourceMappingURL=IconLoader2.js.map
